import { render, staticRenderFns } from "./HealthXinLvChart.vue?vue&type=template&id=c6c3be72&scoped=true&"
import script from "./HealthXinLvChart.vue?vue&type=script&lang=js&"
export * from "./HealthXinLvChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c3be72",
  null
  
)

export default component.exports